module.exports = __webpack_public_path__ + "img/commissionLeads.5238389b.svg";